import {
  Button,
  ErrorText,
  Form,
  FormControl,
  FormField,
  FormItem,
  Input,
} from '@/shared/components';
import { PasswordRulesList } from '@/shared/components';
import type { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { ChangePasswordFormValues } from '../model';

type Props = {
  form: UseFormReturn<ChangePasswordFormValues>;
  onSubmit: (data: ChangePasswordFormValues) => Promise<void>;
  isLoading: boolean;
  error: string | undefined;
  unmetPasswordChecksBeforeSubmit: string[];
  passwordChecks: string[];
};

export const ChangePasswordScreen = ({
  form,
  onSubmit,
  isLoading,
  error,
  unmetPasswordChecksBeforeSubmit,
  passwordChecks,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="flex flex-col gap-[0.8rem]">
        <div className="flex flex-col gap-[1.2rem]">
          <FormField
            control={form.control}
            name="password"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <div className="relative">
                    <Input
                      {...field}
                      showPasswordToggle
                      type="password"
                      autoComplete="new-password"
                      label={t(
                        'personalAccount.userProfile.changePassword.newPasswordPlaceholder'
                      )}
                      className="p3"
                    />
                  </div>
                </FormControl>
              </FormItem>
            )}
          />

          <PasswordRulesList
            password={form.getValues('password')}
            passwordChecks={passwordChecks}
            unmetPasswordChecks={unmetPasswordChecksBeforeSubmit}
            isFormSubmitted={form.formState.isSubmitted}
          />
        </div>

        {error && <ErrorText size="small">{error}</ErrorText>}

        <Button
          loading={isLoading}
          type="submit"
          size="lg"
          className="w-full mt-[2.4rem]">
          {t('personalAccount.userProfile.changePassword.submitButton')}
        </Button>
      </form>
    </Form>
  );
};
